import "core-js/modules/es.array.find-index";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-param-reassign */
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import PropsService from '@/service/props';
export default {
  components: {
    Avatar: Avatar
  },
  data: function data() {
    return {
      visible: false,
      id: '',
      count: 1,
      ticketNum: 0,
      buyParams: null,
      requesting: false
    };
  },
  computed: {
    config: function config() {
      return window.setting.道具配置;
    },
    curStarIndex: function curStarIndex() {
      var _this = this;

      return this.starList.findIndex(function (star) {
        return star.id === _this.id;
      });
    },
    curStar: function curStar() {
      return this.starList[this.curStarIndex];
    },
    toastTexts: function toastTexts() {
      return this.config.toast;
    }
  },
  methods: {
    clear: function clear() {
      this.id = '';
      this.ticketNum = 0;
      this.count = this.myPropsNum;
      this.buyParams = null;
    },
    close: function close() {
      var showShare = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.visible = false;

      if (this.buyParams && showShare) {
        this.eventBus.$emit('launchShare', this.buyParams);
      }

      this.clear();
    },
    bindEvent: function bindEvent() {
      var _this2 = this;

      this.eventBus.$on('showPowerPop', function (params) {
        console.log('event:showPowerPop:call', params);

        if (_this2.isPropsEnd) {
          // 截榜后不显示弹窗
          return;
        }

        if (!params.id) {
          console.error('缺失明星id');
          return;
        }

        _this2.id = params.id;

        if (!_this2.curStar) {
          console.error('明星id有误');
          return;
        }

        if (!_this2.myPropsNum) {
          _this2.pollingProps();
        }

        if (params.count) {
          _this2.count = params.count > _this2.myPropsNum ? _this2.myPropsNum : params.count;
        } else {
          _this2.count = _this2.myPropsNum || 1;
        }

        if (params.ticketNum) {
          _this2.ticketNum = params.ticketNum;
        }

        _this2.buyParams = params.buyParams;
        _this2.visible = true;
      });
    },
    countInputHandler: function countInputHandler(event) {
      var ele = event.target;
      var val = ele.value.trim();
      val = val.replace(/[^\d]/g, '');
      this.$refs.count.value = val;
    },
    countBlurHandler: function countBlurHandler() {
      this.setCount(this.$refs.count.value || 0);
    },
    checkCount: function checkCount(val) {
      if (val < 1) {
        this.toast(this.toastTexts.超下限);
        return 0;
      }

      if (val > this.myPropsNum) {
        this.toast(this.toastTexts.魂力不足);
        return 2;
      }

      return 1;
    },
    setCount: function setCount(val) {
      val = parseInt(val, 10);
      var valid = this.checkCount(val);
      var map = {
        0: 1,
        1: val,
        2: this.myPropsNum
      };
      val = map[valid];
      this.count = val;
      this.$refs.count.value = val;
    },
    sub: function sub() {
      this.setCount(this.count - 1);
    },
    add: function add() {
      this.setCount(this.count + 1);
    },
    refreshPropsState: function refreshPropsState(params) {
      // 赠送魂力值后，刷新相应信息
      this.$store.dispatch('getMyProps');
      this.$store.dispatch('getStarRanks');
      this.eventBus.$emit('refreshRank', params);
    },
    giveProps: function giveProps() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var code;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.isPropsEnd) {
                  _context.next = 3;
                  break;
                }

                _this3.toast('已截止');

                return _context.abrupt("return");

              case 3:
                if (_this3.count) {
                  _context.next = 6;
                  break;
                }

                _this3.toast('请输入要赠送的魂力值数量');

                return _context.abrupt("return");

              case 6:
                if (!(+_this3.count > _this3.myPropsNum)) {
                  _context.next = 9;
                  break;
                }

                _this3.toast(_this3.toastTexts.魂力不足);

                return _context.abrupt("return");

              case 9:
                if (!_this3.requesting) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                _this3.requesting = true;
                _context.prev = 12;
                _context.next = 15;
                return PropsService.giveProps({
                  actorID: _this3.id,
                  giftNum: _this3.count,
                  freeNum: _this3.count
                });

              case 15:
                _this3.refreshPropsState({
                  id: _this3.id
                }); // 拉起赠送魂力成功的弹窗


                _this3.eventBus.$emit('showGetPowerPop', {
                  id: _this3.id,
                  count: _this3.count,
                  buyParams: _this3.buyParams
                }); // 关闭当前选择赠送弹窗


                _this3.close(false);

                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](12);
                code = +_context.t0.code;

                _this3.toast(_context.t0.msg || _context.t0.message || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5~(".concat(code, ")"));

              case 24:
                _this3.requesting = false;

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[12, 20]]);
      }))();
    },
    pollingProps: function pollingProps() {
      var _this4 = this;

      var counts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;

      if (counts < 1) {
        return;
      }

      if (this.myPropsNum) {
        return;
      }

      this.$store.dispatch('getMyProps');
      setTimeout(function () {
        _this4.pollingProps(counts - 1);
      }, 1000);
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};